
<template>
  <div>
    <card-loading-transparent v-if="!chart_ready || loading_dash"></card-loading-transparent>
    <template v-if="chart_ready && !loading_dash">
      <v-col class="px-5">
        <div class="title">{{title}}</div>
        <v-alert v-if="!data.length" type="info" color="concluded" :value="true">
          Não possui dados
        </v-alert>
        <div v-if="data.length" :style="{width: false? '70vw' : ''}">
          <bar-chart ref="ct" v-if="chart_ready" :chart-data="chartData" :options="chartOptions"></bar-chart>
        </div>
      </v-col>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import Vuetify from '@/plugins/vuetify';

export default {
  name: 'RankChart',
  components: {
    BarChart: () => import('@/components/charts/HorizontalBarChart.vue'),
  },
  props: {
    data: {
      type: Array,
      default: [],
    },
    kind:{
      type: String,
      default: 'by_'
    },
    title:{
      type: String,
      default: 'Ranking'
    },
    text_key:{
      type: String,
      default: 'text'
    },
    value_key:{
      type: String,
      default: 'count'
    },
    max_data: {
      type: Number,
      default: 10,
    },
    loading_dash:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      chartData: {
        datasets: [
          {
            //bags
            data: [],
            //has N colors, fusion custom computed
            backgroundColor: '#e33e43', 
            borderColor: [],
            borderWidth: 2,
            hoverBackgroundColor: [],
            label: 'Inconformidades',
          },
          // {
          //   //goals
          //   data: [],
          //   //has N colors, fusion custom computed
          //   backgroundColor: '#FF5252', 
          //   // borderColor: [],
          //   // borderWidth: 2,
          //   // hoverBackgroundColor: [],
          //   label: 'Negativos',
          // },
        ],
        // These labels appear in the legend and in the tooltips when hovering different arcs
        labels: [],
      },
      chartOptions:{
        plugins:{
          
          datalabels: {
            align: 'right',
            anchor: 'bottom',
            // rotation: 90,
            color: function(ctx) {
              // var is_sell = ctx.chart.data.labels[ctx.dataIndex].includes('Ab')
              // return is_sell ? 'white' : 'white'
              return Vuetify.framework.theme.isDark ? 'white' : 'black'
            },
            font: {
              weight: 'bold',
              size: 15
            },
          }
        },
        events: ['click', 'mousemove'],
        onClick: (e)=> {
          this.handleClick(e)
        },
        // cornerRadius: 15,
        scales: {
          yAxes: [{
            display: true,
            stacked: false,
            ticks: {
              fontColor: Vuetify.framework.theme.isDark ? 'white' : 'black',
              mirror: false,
              autoSkip: false,
              callback: function(label, index, labels) {
                return label.length>20? (label.slice(0,19)+'...') : label;
                /*let l = label.split(' ')
                if (l.length == 1 ){
                  return l[0]
                } else {
                  return `${l[0]} ${l[l.length - 1]}`
                }*/
              }
            },
            // barPercentage: 1,
          }],
          xAxes: [{
            stacked: true,
            // barPercentage: 0.5,
            // categoryPercentage: 1.0
          }],
        },
        legend:{
          display: false
        },
        tooltips: {
          enabled: true,
          mode: 'index',
          callbacks: {
            label: function(tooltipItems, data) { 
              //    // auto-comment// console.log({tooltipItems});
              //    // auto-comment// console.log({data});
              // data.datasets[tooltipItems.datasetIndex].label
              return  data.datasets[tooltipItems.datasetIndex].label+ ': ' + tooltipItems.xLabel;
            },
          }
        },
      },
      chart_ready: false,
      local_data: []
      // loading_dash: false,
    }
  },
  methods: {
    handleClick(e){
      try {
        let chart = this.$refs.ct._data._chart
        const activePoints = chart.getElementsAtEventForMode(e, 'nearest', {intersect: true}, true)
        if (activePoints.length){
          const [{_index}] = activePoints;
          const value = this.$refs.ct._props.chartData.datasets[0].data[_index];
          const label = this.$refs.ct._props.chartData.labels[_index];
          this.$emit('chart_clicked', { _index, value, label, data: this.local_data[_index], kind: this.kind })
        }
      } catch (error) {
        console.log(error);
      }
    },
    loadChart(){
      this.chart_ready = false
      // this.chartData.datasets[1].data = [] 
      this.chartData.datasets[0].data = []
      this.chartData.labels = []

      let data = this.data//.filter(d=> d[this.text_key])
      data = [...data] //, ...data]

      data = data.sort((a, b) => a[this.value_key] < b[this.value_key]? 1 : -1 );

      this.local_data = data

      this.chartData.datasets[0].data = [...data.slice(0,this.max_data).map(d => d[this.value_key])] // , ...this.oneForm.items.map(ans => ans.total_ok+2),...this.oneForm.items.map(ans => ans.total_ok+2)]
      // this.chartData.datasets[1].data = [...this.oneForm.items.map(ans => -ans.total_nok)] //, ...this.oneForm.items.map(ans => -ans.total_nok-2),...this.oneForm.items.map(ans => -ans.total_nok-2)]
      this.chartData.labels = [...data.slice(0,this.max_data).map(d => {
        return `${d[this.text_key].toUpperCase()}`
      })] //,...this.oneForm.items.map(ans => `${ans.title} - 2`),...this.oneForm.items.map(ans => `${ans.title} - 3`)]

      setTimeout(() => {
        this.chart_ready = true
      }, 500);
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted () {
    this.loadChart();
  },
  computed: {
    asd() {
      return 'red'
    },
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv.length){
        this.loadChart()
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>